import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export default function PrivateRoute({ children }: PrivateRouteProps) {
  const { session, loading } = useAuth();
  const location = useLocation();

  console.log('PrivateRoute render:', {
    loading,
    hasSession: !!session,
    path: location.pathname
  });

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!session) {
    console.log('No session, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  console.log('Rendering protected content');
  return <>{children}</>;
}
